export const HISTORY_HEDGES = {
  HISTORY_OF_BLANKET: 'History of blanket hedge',
  PT_HEDGE: 'Pt Hedge',
  PD_HEDGE: 'Pd Hedge',
  RH_HEDGE: 'Rh Hedge',
  HEDGE_APPLIED_ON: 'Applied on',
  LOT_APPLIED_TO: 'Lot applied to',
  OUNCES_AVAILABLE: 'Ounces available',
};
